import { Decimal } from 'decimal.js';
export function formatNumberWithCommas(num) {
    const decimal = new Decimal(num);
    const str = decimal.toFixed(decimal.isInteger() ? 0 : 2);
    return str.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
export function formatDollarAmount(amount) {
    const decimal = new Decimal(amount);
    const isNegative = decimal.lessThan(0);
    return "".concat(isNegative ? '-' : '', "$").concat(formatNumberWithCommas(isNegative ? decimal.abs().toNumber() : decimal));
}
